import { ipsos, supuesto } from ".";

// Lámina 77 (base 400 general / 106 inversores).
const P_INVIERTE = "¿Realiza algún tipo de inversión?";
const P_TIPO = "¿En qué tipo de instrumento invierte?";
const P_PRIORIDAD = "¿Qué prioriza al momento de invertir?";
const P_CANAL = "¿A través de qué canal invierte?";

export const IPSOS_INVERSIONES = {
  realizaInversiones: ipsos(0.26, { lamina: 77, pregunta: P_INVIERTE, base: 400 }),
  noRealizaInversiones: ipsos(0.74, { lamina: 77, pregunta: P_INVIERTE, base: 400, nota: "oportunidad de captación" }),

  tiposInversion: {
    "Depósito a Plazo": ipsos(0.431, { lamina: 77, pregunta: P_TIPO, base: 106 }),
    "Fondos Mutuos": ipsos(0.257, { lamina: 77, pregunta: P_TIPO, base: 106 }),
    Acciones: ipsos(0.195, { lamina: 77, pregunta: P_TIPO, base: 106 }),
    Criptomonedas: ipsos(0.176, { lamina: 77, pregunta: P_TIPO, base: 106 }),
    Otro: ipsos(0.099, { lamina: 77, pregunta: P_TIPO, base: 106 }),
    Bolsa: ipsos(0.053, { lamina: 77, pregunta: P_TIPO, base: 106 }),
  },

  prioridades: {
    Rentabilidad: ipsos(0.449, { lamina: 77, pregunta: P_PRIORIDAD, base: 106 }),
    Seguridad: ipsos(0.334, { lamina: 77, pregunta: P_PRIORIDAD, base: 106 }),
    Liquidez: ipsos(0.218, { lamina: 77, pregunta: P_PRIORIDAD, base: 106 }),
  },

  canales: {
    "Banca privada": ipsos(0.612, { lamina: 77, pregunta: P_CANAL, base: 106 }),
    "Plataforma online": ipsos(0.246, { lamina: 77, pregunta: P_CANAL, base: 106 }),
    "Corredora de bolsa": ipsos(0.097, { lamina: 77, pregunta: P_CANAL, base: 106 }),
    Otro: ipsos(0.045, { lamina: 77, pregunta: P_CANAL, base: 106 }),
    "Firma de asesorías": ipsos(0.042, { lamina: 77, pregunta: P_CANAL, base: 106 }),
  },
};

// Supuestos comerciales (USD)
export const TICKETS_INVERSION = [
  supuesto(5000, { nota: "ticket de inversión (USD)" }),
  supuesto(10000, { nota: "ticket de inversión (USD)" }),
  supuesto(25000, { nota: "ticket de inversión (USD)" }),
  supuesto(50000, { nota: "ticket de inversión (USD)" }),
];

export const ESCENARIOS_CRECIMIENTO_INVERSIONES = [
  supuesto(5, { nota: "% crecimiento de share simulado" }),
  supuesto(10, { nota: "% crecimiento de share simulado" }),
  supuesto(20, { nota: "% crecimiento de share simulado" }),
  supuesto(30, { nota: "% crecimiento de share simulado" }),
];

// Fracción del 74% no inversor que se supone captable por cada punto de crecimiento simulado
export const FACTOR_CAPTACION_NO_INVERSORES = supuesto(0.1, {
  nota: "fracción de no inversores captada por punto de crecimiento simulado",
});
